import React from 'react';
import StyledButtonBase from 'views/rebranded-module/common/components/UI/IconicRideCard/IconicRideCard.styles';
import { Box, Typography } from '@mui/material';
import {
  ImgBox,
  Typography700,
} from 'views/rebranded-module/common/components';
import NavigatorLink from 'views/rebranded-module/common/components/Logical/NavigatorLink';

const IconicRideCard = (props) => {
  const {
    title, image, link, description, dataTestId,
  } = props;

  return (
    <StyledButtonBase
      component={NavigatorLink}
      href={link}
      data-testid={dataTestId}
      sx={{ width: '100%' }}>
      <Box className="IRCImgContainer">
        <ImgBox
          image={{
            src: image || '/imgs/Rebranding/logos/default.jpg',
            alt: title,
          }}
          width="100%"
          height="100%"
          objectFit="cover"
          unoptimized
        />
      </Box>
      <Box className="TCInfo">
        <Typography700 className="TCTitle" variant="h4" component="p">
          {title}
        </Typography700>
        {description && (
          <Typography
            className="TCSubTitle"
            variant="body1"
            component="p"
            pt={2}>
            {description}
          </Typography>
        )}
      </Box>
    </StyledButtonBase>
  );
};

export { IconicRideCard };
